module.exports = __webpack_public_path__ + "media/da_dk_s2_Grete.06d59d8e.oga";